export const VEHICLE_MESSAGE_STRINGS = {
	SEE_AD_TITLE: 'Ver anúncio',
} as const;
